import type { PropsWithChildren, ReactNode } from 'react'
import React, { memo } from 'react'

const BADGE_TONE = {
  teal: 'bg-teal-50 text-teal-600',
  green: 'bg-green-50 text-green-600',
}

export interface LinkButtonProps {
  href: string
  icon: ReactNode
  tone?: keyof typeof BADGE_TONE
  newTab?: boolean
}

const LinkButton: React.FC<PropsWithChildren<LinkButtonProps>> = memo(
  ({ href, icon, tone = 'teal', newTab, children }) => {
    const opensInNewTab = newTab ?? /^https?:\/\//.test(href)
    return (
      <a
        href={href}
        {...(opensInNewTab
          ? { target: '_blank', rel: 'noopener noreferrer' }
          : {})}
        className="flex items-center gap-4 w-full bg-white border border-teal-200 rounded-2xl px-4 py-4 shadow-sm hover:shadow-md hover:border-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 transition-all"
      >
        <span
          className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center p-2.5 ${BADGE_TONE[tone]}`}
        >
          {icon}
        </span>
        <span className="text-teal-800 font-semibold text-base text-left leading-snug">
          {children}
        </span>
      </a>
    )
  },
)
LinkButton.displayName = 'LinkButton'

export default LinkButton
